import { render, staticRenderFns } from "./job_not_found.html?vue&type=template&id=b63a349a&scoped=true&"
import script from "./job_not_found.vue?vue&type=script&scoped=true&lang=js&"
export * from "./job_not_found.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./job_not_found.scss?vue&type=style&index=0&id=b63a349a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a349a",
  null
  
)

export default component.exports